module.exports = __webpack_public_path__ + "img/empty.25268a36.png";